/* tslint:disable */
/* eslint-disable */
/**
 * Abekus Open API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminSendMobileAppNotificationBody } from '../models';
// @ts-ignore
import type { AdminSendMobileAppNotificationResponse } from '../models';
// @ts-ignore
import type { AdminTestCronNotificationBody } from '../models';
// @ts-ignore
import type { AdminTestCronNotificationResponse } from '../models';
// @ts-ignore
import type { CreateEmailNotification } from '../models';
// @ts-ignore
import type { CreateEmailNotificationResponse } from '../models';
// @ts-ignore
import type { ErrorResponse } from '../models';
// @ts-ignore
import type { GetAdminPushNotificationUsersResponse } from '../models';
// @ts-ignore
import type { GetAdminPushNotificationsResponse } from '../models';
// @ts-ignore
import type { GetEmailNotification } from '../models';
// @ts-ignore
import type { GetInAppNotificationsResponse } from '../models';
// @ts-ignore
import type { GetUserNotificationSettingsResponse } from '../models';
// @ts-ignore
import type { GetWhatsappConversationsResponse } from '../models';
// @ts-ignore
import type { GetWhatsappLogsResponse } from '../models';
// @ts-ignore
import type { GetWhatsappTemplatesResponse } from '../models';
// @ts-ignore
import type { GetWhatsappThreadResponse } from '../models';
// @ts-ignore
import type { InAppNotification } from '../models';
// @ts-ignore
import type { SuccessResponseBase } from '../models';
// @ts-ignore
import type { ToggleUserEmailNotifications } from '../models';
// @ts-ignore
import type { UnreadCountResponse } from '../models';
// @ts-ignore
import type { UpdateEmailNotificationsResponse } from '../models';
// @ts-ignore
import type { UpdatePushDigestFrequency } from '../models';
// @ts-ignore
import type { WebPushSubscribeBody } from '../models';
// @ts-ignore
import type { WebPushUnsubscribeBody } from '../models';
// @ts-ignore
import type { WhatsappMarketingNotificationSuccessBody } from '../models';
// @ts-ignore
import type { WhatsappMarketingNotificationSuccessResponse } from '../models';
// @ts-ignore
import type { WhatsappReplyBody } from '../models';
// @ts-ignore
import type { WhatsappReplyResponse } from '../models';
/**
 * NotificationApiApi - axios parameter creator
 */
export const NotificationApiApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AdminSendMobileAppNotificationBody} adminSendMobileAppNotificationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiAdminSendMobileAppNotification: async (adminSendMobileAppNotificationBody: AdminSendMobileAppNotificationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminSendMobileAppNotificationBody' is not null or undefined
            assertParamExists('notificationApiAdminSendMobileAppNotification', 'adminSendMobileAppNotificationBody', adminSendMobileAppNotificationBody)
            const localVarPath = `/admin/send-mobile-app-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminSendMobileAppNotificationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminTestCronNotificationBody} adminTestCronNotificationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiAdminTestCronMobileNotification: async (adminTestCronNotificationBody: AdminTestCronNotificationBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminTestCronNotificationBody' is not null or undefined
            assertParamExists('notificationApiAdminTestCronMobileNotification', 'adminTestCronNotificationBody', adminTestCronNotificationBody)
            const localVarPath = `/admin/test-cron-mobile-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminTestCronNotificationBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateEmailNotification} createEmailNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiCreateEmailNotifications: async (createEmailNotification: CreateEmailNotification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailNotification' is not null or undefined
            assertParamExists('notificationApiCreateEmailNotifications', 'createEmailNotification', createEmailNotification)
            const localVarPath = `/admin/email/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailNotificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiDeleteEmailNotifications: async (emailNotificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailNotificationId' is not null or undefined
            assertParamExists('notificationApiDeleteEmailNotifications', 'emailNotificationId', emailNotificationId)
            const localVarPath = `/admin/email/notifications/{email_notification_id}`
                .replace('{email_notification_id}', encodeURIComponent(String(emailNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebPushUnsubscribeBody} webPushUnsubscribeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiDeleteWebPushSubscription: async (webPushUnsubscribeBody: WebPushUnsubscribeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webPushUnsubscribeBody' is not null or undefined
            assertParamExists('notificationApiDeleteWebPushSubscription', 'webPushUnsubscribeBody', webPushUnsubscribeBody)
            const localVarPath = `/web-push/subscriptions/remove`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushUnsubscribeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiDismissWebPushPrompt: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/web-push/prompt/dismiss`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetAdminPushNotificationUsers: async (groupId: string, page?: string, pageSize?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'groupId' is not null or undefined
            assertParamExists('notificationApiGetAdminPushNotificationUsers', 'groupId', groupId)
            const localVarPath = `/admin/push-notifications/{group_id}/users`
                .replace('{group_id}', encodeURIComponent(String(groupId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [notificationType] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetAdminPushNotifications: async (notificationType?: string | null, page?: string, pageSize?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/push-notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (notificationType !== undefined) {
                localVarQueryParameter['notification_type'] = notificationType;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetEmailNotifications: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/email/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NotificationApiGetInAppNotificationsScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetInAppNotifications: async (page?: number, pageSize?: number, scope?: NotificationApiGetInAppNotificationsScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/in-app/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationApiGetInAppNotificationsUnreadCountScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetInAppNotificationsUnreadCount: async (scope?: NotificationApiGetInAppNotificationsUnreadCountScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/in-app/notifications/unread-count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetUserNotificationsByUserType: async (userType: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userType' is not null or undefined
            assertParamExists('notificationApiGetUserNotificationsByUserType', 'userType', userType)
            const localVarPath = `/email/{user_type}/notifications`
                .replace('{user_type}', encodeURIComponent(String(userType)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappConversations: async (page?: number, pageSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/whatsapp-conversations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string | null} [maxDate] 
         * @param {string | null} [messageStatus] 
         * @param {string | null} [messageType] 
         * @param {string | null} [minDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [phone] 
         * @param {string | null} [templateName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappLogs: async (maxDate?: string | null, messageStatus?: string | null, messageType?: string | null, minDate?: string | null, page?: number, pageSize?: number, phone?: string | null, templateName?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/admin/whatsapp-logs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (maxDate !== undefined) {
                localVarQueryParameter['max_date'] = maxDate;
            }

            if (messageStatus !== undefined) {
                localVarQueryParameter['message_status'] = messageStatus;
            }

            if (messageType !== undefined) {
                localVarQueryParameter['message_type'] = messageType;
            }

            if (minDate !== undefined) {
                localVarQueryParameter['min_date'] = minDate;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            if (templateName !== undefined) {
                localVarQueryParameter['template_name'] = templateName;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappTemplates: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/get-whatsapp-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappThread: async (phone: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'phone' is not null or undefined
            assertParamExists('notificationApiGetWhatsappThread', 'phone', phone)
            const localVarPath = `/admin/whatsapp-thread`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (phone !== undefined) {
                localVarQueryParameter['phone'] = phone;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NotificationApiMarkAllInAppNotificationsReadScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiMarkAllInAppNotificationsRead: async (scope?: NotificationApiMarkAllInAppNotificationsReadScopeEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/in-app/notifications/read-all`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (scope !== undefined) {
                localVarQueryParameter['scope'] = scope;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiMarkInAppNotificationRead: async (notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('notificationApiMarkInAppNotificationRead', 'notificationId', notificationId)
            const localVarPath = `/in-app/notifications/{notification_id}/read`
                .replace('{notification_id}', encodeURIComponent(String(notificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WebPushSubscribeBody} webPushSubscribeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiSaveWebPushSubscription: async (webPushSubscribeBody: WebPushSubscribeBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'webPushSubscribeBody' is not null or undefined
            assertParamExists('notificationApiSaveWebPushSubscription', 'webPushSubscribeBody', webPushSubscribeBody)
            const localVarPath = `/web-push/subscriptions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(webPushSubscribeBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} paramValue 
         * @param {string} templateName 
         * @param {string} toNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiSendWhatsapp: async (paramValue: string, templateName: string, toNumber: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'paramValue' is not null or undefined
            assertParamExists('notificationApiSendWhatsapp', 'paramValue', paramValue)
            // verify required parameter 'templateName' is not null or undefined
            assertParamExists('notificationApiSendWhatsapp', 'templateName', templateName)
            // verify required parameter 'toNumber' is not null or undefined
            assertParamExists('notificationApiSendWhatsapp', 'toNumber', toNumber)
            const localVarPath = `/test-whatsapp-notification/{to_number}/{param_value}/{template_name}`
                .replace('{param_value}', encodeURIComponent(String(paramValue)))
                .replace('{template_name}', encodeURIComponent(String(templateName)))
                .replace('{to_number}', encodeURIComponent(String(toNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WhatsappMarketingNotificationSuccessBody} whatsappMarketingNotificationSuccessBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiSendWhatsappMarketingNotification: async (whatsappMarketingNotificationSuccessBody: WhatsappMarketingNotificationSuccessBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'whatsappMarketingNotificationSuccessBody' is not null or undefined
            assertParamExists('notificationApiSendWhatsappMarketingNotification', 'whatsappMarketingNotificationSuccessBody', whatsappMarketingNotificationSuccessBody)
            const localVarPath = `/whatsapp/send-marketing-notification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whatsappMarketingNotificationSuccessBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ToggleUserEmailNotifications} toggleUserEmailNotifications 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiToggleEmailNotifications: async (toggleUserEmailNotifications: ToggleUserEmailNotifications, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'toggleUserEmailNotifications' is not null or undefined
            assertParamExists('notificationApiToggleEmailNotifications', 'toggleUserEmailNotifications', toggleUserEmailNotifications)
            const localVarPath = `/email/notifications/toggle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleUserEmailNotifications, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} emailNotificationId 
         * @param {CreateEmailNotification} createEmailNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiUpdateEmailNotifications: async (emailNotificationId: string, createEmailNotification: CreateEmailNotification, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailNotificationId' is not null or undefined
            assertParamExists('notificationApiUpdateEmailNotifications', 'emailNotificationId', emailNotificationId)
            // verify required parameter 'createEmailNotification' is not null or undefined
            assertParamExists('notificationApiUpdateEmailNotifications', 'createEmailNotification', createEmailNotification)
            const localVarPath = `/admin/email/notifications/{email_notification_id}`
                .replace('{email_notification_id}', encodeURIComponent(String(emailNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailNotification, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdatePushDigestFrequency} updatePushDigestFrequency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiUpdatePushDigestFrequency: async (updatePushDigestFrequency: UpdatePushDigestFrequency, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updatePushDigestFrequency' is not null or undefined
            assertParamExists('notificationApiUpdatePushDigestFrequency', 'updatePushDigestFrequency', updatePushDigestFrequency)
            const localVarPath = `/push-notifications/frequency`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePushDigestFrequency, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} interactionType 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiUpdatePushNotificationInteraction: async (interactionType: string, notificationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'interactionType' is not null or undefined
            assertParamExists('notificationApiUpdatePushNotificationInteraction', 'interactionType', interactionType)
            // verify required parameter 'notificationId' is not null or undefined
            assertParamExists('notificationApiUpdatePushNotificationInteraction', 'notificationId', notificationId)
            const localVarPath = `/push-notifications/interaction`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (interactionType !== undefined) {
                localVarQueryParameter['interaction_type'] = interactionType;
            }

            if (notificationId !== undefined) {
                localVarQueryParameter['notification_id'] = notificationId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WhatsappReplyBody} whatsappReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiWhatsappAdminReply: async (whatsappReplyBody: WhatsappReplyBody, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'whatsappReplyBody' is not null or undefined
            assertParamExists('notificationApiWhatsappAdminReply', 'whatsappReplyBody', whatsappReplyBody)
            const localVarPath = `/admin/whatsapp/reply`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication token_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(whatsappReplyBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApiApi - functional programming interface
 */
export const NotificationApiApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {AdminSendMobileAppNotificationBody} adminSendMobileAppNotificationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiAdminSendMobileAppNotification(adminSendMobileAppNotificationBody: AdminSendMobileAppNotificationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSendMobileAppNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiAdminSendMobileAppNotification(adminSendMobileAppNotificationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiAdminSendMobileAppNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {AdminTestCronNotificationBody} adminTestCronNotificationBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiAdminTestCronMobileNotification(adminTestCronNotificationBody: AdminTestCronNotificationBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTestCronNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiAdminTestCronMobileNotification(adminTestCronNotificationBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiAdminTestCronMobileNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateEmailNotification} createEmailNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiCreateEmailNotifications(createEmailNotification: CreateEmailNotification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateEmailNotificationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiCreateEmailNotifications(createEmailNotification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiCreateEmailNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailNotificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiDeleteEmailNotifications(emailNotificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiDeleteEmailNotifications(emailNotificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiDeleteEmailNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebPushUnsubscribeBody} webPushUnsubscribeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiDeleteWebPushSubscription(webPushUnsubscribeBody: WebPushUnsubscribeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiDeleteWebPushSubscription(webPushUnsubscribeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiDeleteWebPushSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiDismissWebPushPrompt(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiDismissWebPushPrompt(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiDismissWebPushPrompt']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} groupId 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetAdminPushNotificationUsers(groupId: string, page?: string, pageSize?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminPushNotificationUsersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetAdminPushNotificationUsers(groupId, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetAdminPushNotificationUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [notificationType] 
         * @param {string} [page] 
         * @param {string} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetAdminPushNotifications(notificationType?: string | null, page?: string, pageSize?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetAdminPushNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetAdminPushNotifications(notificationType, page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetAdminPushNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetEmailNotifications(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetEmailNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetEmailNotifications(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetEmailNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {NotificationApiGetInAppNotificationsScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetInAppNotifications(page?: number, pageSize?: number, scope?: NotificationApiGetInAppNotificationsScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInAppNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetInAppNotifications(page, pageSize, scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetInAppNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationApiGetInAppNotificationsUnreadCountScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetInAppNotificationsUnreadCount(scope?: NotificationApiGetInAppNotificationsUnreadCountScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UnreadCountResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetInAppNotificationsUnreadCount(scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetInAppNotificationsUnreadCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} userType 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetUserNotificationsByUserType(userType: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserNotificationSettingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetUserNotificationsByUserType(userType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetUserNotificationsByUserType']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetWhatsappConversations(page?: number, pageSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWhatsappConversationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetWhatsappConversations(page, pageSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetWhatsappConversations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string | null} [maxDate] 
         * @param {string | null} [messageStatus] 
         * @param {string | null} [messageType] 
         * @param {string | null} [minDate] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string | null} [phone] 
         * @param {string | null} [templateName] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetWhatsappLogs(maxDate?: string | null, messageStatus?: string | null, messageType?: string | null, minDate?: string | null, page?: number, pageSize?: number, phone?: string | null, templateName?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWhatsappLogsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetWhatsappLogs(maxDate, messageStatus, messageType, minDate, page, pageSize, phone, templateName, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetWhatsappLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetWhatsappTemplates(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWhatsappTemplatesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetWhatsappTemplates(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetWhatsappTemplates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} phone 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiGetWhatsappThread(phone: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWhatsappThreadResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiGetWhatsappThread(phone, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiGetWhatsappThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {NotificationApiMarkAllInAppNotificationsReadScopeEnum} [scope] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiMarkAllInAppNotificationsRead(scope?: NotificationApiMarkAllInAppNotificationsReadScopeEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiMarkAllInAppNotificationsRead(scope, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiMarkAllInAppNotificationsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiMarkInAppNotificationRead(notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InAppNotification>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiMarkInAppNotificationRead(notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiMarkInAppNotificationRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WebPushSubscribeBody} webPushSubscribeBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiSaveWebPushSubscription(webPushSubscribeBody: WebPushSubscribeBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiSaveWebPushSubscription(webPushSubscribeBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiSaveWebPushSubscription']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} paramValue 
         * @param {string} templateName 
         * @param {string} toNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiSendWhatsapp(paramValue: string, templateName: string, toNumber: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiSendWhatsapp(paramValue, templateName, toNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiSendWhatsapp']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WhatsappMarketingNotificationSuccessBody} whatsappMarketingNotificationSuccessBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiSendWhatsappMarketingNotification(whatsappMarketingNotificationSuccessBody: WhatsappMarketingNotificationSuccessBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatsappMarketingNotificationSuccessResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiSendWhatsappMarketingNotification(whatsappMarketingNotificationSuccessBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiSendWhatsappMarketingNotification']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {ToggleUserEmailNotifications} toggleUserEmailNotifications 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiToggleEmailNotifications(toggleUserEmailNotifications: ToggleUserEmailNotifications, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiToggleEmailNotifications(toggleUserEmailNotifications, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiToggleEmailNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} emailNotificationId 
         * @param {CreateEmailNotification} createEmailNotification 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiUpdateEmailNotifications(emailNotificationId: string, createEmailNotification: CreateEmailNotification, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateEmailNotificationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiUpdateEmailNotifications(emailNotificationId, createEmailNotification, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiUpdateEmailNotifications']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdatePushDigestFrequency} updatePushDigestFrequency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiUpdatePushDigestFrequency(updatePushDigestFrequency: UpdatePushDigestFrequency, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiUpdatePushDigestFrequency(updatePushDigestFrequency, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiUpdatePushDigestFrequency']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} interactionType 
         * @param {string} notificationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiUpdatePushNotificationInteraction(interactionType: string, notificationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SuccessResponseBase>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiUpdatePushNotificationInteraction(interactionType, notificationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiUpdatePushNotificationInteraction']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {WhatsappReplyBody} whatsappReplyBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationApiWhatsappAdminReply(whatsappReplyBody: WhatsappReplyBody, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhatsappReplyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationApiWhatsappAdminReply(whatsappReplyBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApiApi.notificationApiWhatsappAdminReply']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApiApi - factory interface
 */
export const NotificationApiApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiApiFp(configuration)
    return {
        /**
         * 
         * @param {NotificationApiApiNotificationApiAdminSendMobileAppNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiAdminSendMobileAppNotification(requestParameters: NotificationApiApiNotificationApiAdminSendMobileAppNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminSendMobileAppNotificationResponse> {
            return localVarFp.notificationApiAdminSendMobileAppNotification(requestParameters.adminSendMobileAppNotificationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiAdminTestCronMobileNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiAdminTestCronMobileNotification(requestParameters: NotificationApiApiNotificationApiAdminTestCronMobileNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<AdminTestCronNotificationResponse> {
            return localVarFp.notificationApiAdminTestCronMobileNotification(requestParameters.adminTestCronNotificationBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiCreateEmailNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiCreateEmailNotifications(requestParameters: NotificationApiApiNotificationApiCreateEmailNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateEmailNotificationResponse> {
            return localVarFp.notificationApiCreateEmailNotifications(requestParameters.createEmailNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiDeleteEmailNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiDeleteEmailNotifications(requestParameters: NotificationApiApiNotificationApiDeleteEmailNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiDeleteEmailNotifications(requestParameters.emailNotificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiDeleteWebPushSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiDeleteWebPushSubscription(requestParameters: NotificationApiApiNotificationApiDeleteWebPushSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiDeleteWebPushSubscription(requestParameters.webPushUnsubscribeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiDismissWebPushPrompt(options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiDismissWebPushPrompt(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetAdminPushNotificationUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetAdminPushNotificationUsers(requestParameters: NotificationApiApiNotificationApiGetAdminPushNotificationUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminPushNotificationUsersResponse> {
            return localVarFp.notificationApiGetAdminPushNotificationUsers(requestParameters.groupId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetAdminPushNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetAdminPushNotifications(requestParameters: NotificationApiApiNotificationApiGetAdminPushNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetAdminPushNotificationsResponse> {
            return localVarFp.notificationApiGetAdminPushNotifications(requestParameters.notificationType, requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetEmailNotifications(options?: RawAxiosRequestConfig): AxiosPromise<GetEmailNotification> {
            return localVarFp.notificationApiGetEmailNotifications(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetInAppNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetInAppNotifications(requestParameters: NotificationApiApiNotificationApiGetInAppNotificationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetInAppNotificationsResponse> {
            return localVarFp.notificationApiGetInAppNotifications(requestParameters.page, requestParameters.pageSize, requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetInAppNotificationsUnreadCountRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetInAppNotificationsUnreadCount(requestParameters: NotificationApiApiNotificationApiGetInAppNotificationsUnreadCountRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<UnreadCountResponse> {
            return localVarFp.notificationApiGetInAppNotificationsUnreadCount(requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetUserNotificationsByUserTypeRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetUserNotificationsByUserType(requestParameters: NotificationApiApiNotificationApiGetUserNotificationsByUserTypeRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUserNotificationSettingsResponse> {
            return localVarFp.notificationApiGetUserNotificationsByUserType(requestParameters.userType, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetWhatsappConversationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappConversations(requestParameters: NotificationApiApiNotificationApiGetWhatsappConversationsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetWhatsappConversationsResponse> {
            return localVarFp.notificationApiGetWhatsappConversations(requestParameters.page, requestParameters.pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetWhatsappLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappLogs(requestParameters: NotificationApiApiNotificationApiGetWhatsappLogsRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<GetWhatsappLogsResponse> {
            return localVarFp.notificationApiGetWhatsappLogs(requestParameters.maxDate, requestParameters.messageStatus, requestParameters.messageType, requestParameters.minDate, requestParameters.page, requestParameters.pageSize, requestParameters.phone, requestParameters.templateName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappTemplates(options?: RawAxiosRequestConfig): AxiosPromise<GetWhatsappTemplatesResponse> {
            return localVarFp.notificationApiGetWhatsappTemplates(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiGetWhatsappThreadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiGetWhatsappThread(requestParameters: NotificationApiApiNotificationApiGetWhatsappThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetWhatsappThreadResponse> {
            return localVarFp.notificationApiGetWhatsappThread(requestParameters.phone, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiMarkAllInAppNotificationsReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiMarkAllInAppNotificationsRead(requestParameters: NotificationApiApiNotificationApiMarkAllInAppNotificationsReadRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiMarkAllInAppNotificationsRead(requestParameters.scope, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiMarkInAppNotificationReadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiMarkInAppNotificationRead(requestParameters: NotificationApiApiNotificationApiMarkInAppNotificationReadRequest, options?: RawAxiosRequestConfig): AxiosPromise<InAppNotification> {
            return localVarFp.notificationApiMarkInAppNotificationRead(requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiSaveWebPushSubscriptionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiSaveWebPushSubscription(requestParameters: NotificationApiApiNotificationApiSaveWebPushSubscriptionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiSaveWebPushSubscription(requestParameters.webPushSubscribeBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiSendWhatsappRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiSendWhatsapp(requestParameters: NotificationApiApiNotificationApiSendWhatsappRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiSendWhatsapp(requestParameters.paramValue, requestParameters.templateName, requestParameters.toNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiSendWhatsappMarketingNotificationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiSendWhatsappMarketingNotification(requestParameters: NotificationApiApiNotificationApiSendWhatsappMarketingNotificationRequest, options?: RawAxiosRequestConfig): AxiosPromise<WhatsappMarketingNotificationSuccessResponse> {
            return localVarFp.notificationApiSendWhatsappMarketingNotification(requestParameters.whatsappMarketingNotificationSuccessBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiToggleEmailNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiToggleEmailNotifications(requestParameters: NotificationApiApiNotificationApiToggleEmailNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiToggleEmailNotifications(requestParameters.toggleUserEmailNotifications, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiUpdateEmailNotificationsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiUpdateEmailNotifications(requestParameters: NotificationApiApiNotificationApiUpdateEmailNotificationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateEmailNotificationsResponse> {
            return localVarFp.notificationApiUpdateEmailNotifications(requestParameters.emailNotificationId, requestParameters.createEmailNotification, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiUpdatePushDigestFrequencyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiUpdatePushDigestFrequency(requestParameters: NotificationApiApiNotificationApiUpdatePushDigestFrequencyRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiUpdatePushDigestFrequency(requestParameters.updatePushDigestFrequency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiUpdatePushNotificationInteractionRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiUpdatePushNotificationInteraction(requestParameters: NotificationApiApiNotificationApiUpdatePushNotificationInteractionRequest, options?: RawAxiosRequestConfig): AxiosPromise<SuccessResponseBase> {
            return localVarFp.notificationApiUpdatePushNotificationInteraction(requestParameters.interactionType, requestParameters.notificationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {NotificationApiApiNotificationApiWhatsappAdminReplyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationApiWhatsappAdminReply(requestParameters: NotificationApiApiNotificationApiWhatsappAdminReplyRequest, options?: RawAxiosRequestConfig): AxiosPromise<WhatsappReplyResponse> {
            return localVarFp.notificationApiWhatsappAdminReply(requestParameters.whatsappReplyBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for notificationApiAdminSendMobileAppNotification operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiAdminSendMobileAppNotificationRequest {
    readonly adminSendMobileAppNotificationBody: AdminSendMobileAppNotificationBody
}

/**
 * Request parameters for notificationApiAdminTestCronMobileNotification operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiAdminTestCronMobileNotificationRequest {
    readonly adminTestCronNotificationBody: AdminTestCronNotificationBody
}

/**
 * Request parameters for notificationApiCreateEmailNotifications operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiCreateEmailNotificationsRequest {
    readonly createEmailNotification: CreateEmailNotification
}

/**
 * Request parameters for notificationApiDeleteEmailNotifications operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiDeleteEmailNotificationsRequest {
    readonly emailNotificationId: string
}

/**
 * Request parameters for notificationApiDeleteWebPushSubscription operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiDeleteWebPushSubscriptionRequest {
    readonly webPushUnsubscribeBody: WebPushUnsubscribeBody
}

/**
 * Request parameters for notificationApiGetAdminPushNotificationUsers operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetAdminPushNotificationUsersRequest {
    readonly groupId: string

    readonly page?: string

    readonly pageSize?: string
}

/**
 * Request parameters for notificationApiGetAdminPushNotifications operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetAdminPushNotificationsRequest {
    readonly notificationType?: string | null

    readonly page?: string

    readonly pageSize?: string
}

/**
 * Request parameters for notificationApiGetInAppNotifications operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetInAppNotificationsRequest {
    readonly page?: number

    readonly pageSize?: number

    readonly scope?: NotificationApiGetInAppNotificationsScopeEnum
}

/**
 * Request parameters for notificationApiGetInAppNotificationsUnreadCount operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetInAppNotificationsUnreadCountRequest {
    readonly scope?: NotificationApiGetInAppNotificationsUnreadCountScopeEnum
}

/**
 * Request parameters for notificationApiGetUserNotificationsByUserType operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetUserNotificationsByUserTypeRequest {
    readonly userType: string
}

/**
 * Request parameters for notificationApiGetWhatsappConversations operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetWhatsappConversationsRequest {
    readonly page?: number

    readonly pageSize?: number
}

/**
 * Request parameters for notificationApiGetWhatsappLogs operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetWhatsappLogsRequest {
    readonly maxDate?: string | null

    readonly messageStatus?: string | null

    readonly messageType?: string | null

    readonly minDate?: string | null

    readonly page?: number

    readonly pageSize?: number

    readonly phone?: string | null

    readonly templateName?: string | null
}

/**
 * Request parameters for notificationApiGetWhatsappThread operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiGetWhatsappThreadRequest {
    readonly phone: string
}

/**
 * Request parameters for notificationApiMarkAllInAppNotificationsRead operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiMarkAllInAppNotificationsReadRequest {
    readonly scope?: NotificationApiMarkAllInAppNotificationsReadScopeEnum
}

/**
 * Request parameters for notificationApiMarkInAppNotificationRead operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiMarkInAppNotificationReadRequest {
    readonly notificationId: string
}

/**
 * Request parameters for notificationApiSaveWebPushSubscription operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiSaveWebPushSubscriptionRequest {
    readonly webPushSubscribeBody: WebPushSubscribeBody
}

/**
 * Request parameters for notificationApiSendWhatsapp operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiSendWhatsappRequest {
    readonly paramValue: string

    readonly templateName: string

    readonly toNumber: string
}

/**
 * Request parameters for notificationApiSendWhatsappMarketingNotification operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiSendWhatsappMarketingNotificationRequest {
    readonly whatsappMarketingNotificationSuccessBody: WhatsappMarketingNotificationSuccessBody
}

/**
 * Request parameters for notificationApiToggleEmailNotifications operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiToggleEmailNotificationsRequest {
    readonly toggleUserEmailNotifications: ToggleUserEmailNotifications
}

/**
 * Request parameters for notificationApiUpdateEmailNotifications operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiUpdateEmailNotificationsRequest {
    readonly emailNotificationId: string

    readonly createEmailNotification: CreateEmailNotification
}

/**
 * Request parameters for notificationApiUpdatePushDigestFrequency operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiUpdatePushDigestFrequencyRequest {
    readonly updatePushDigestFrequency: UpdatePushDigestFrequency
}

/**
 * Request parameters for notificationApiUpdatePushNotificationInteraction operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiUpdatePushNotificationInteractionRequest {
    readonly interactionType: string

    readonly notificationId: string
}

/**
 * Request parameters for notificationApiWhatsappAdminReply operation in NotificationApiApi.
 */
export interface NotificationApiApiNotificationApiWhatsappAdminReplyRequest {
    readonly whatsappReplyBody: WhatsappReplyBody
}

/**
 * NotificationApiApi - object-oriented interface
 */
export class NotificationApiApi extends BaseAPI {
    /**
     * 
     * @param {NotificationApiApiNotificationApiAdminSendMobileAppNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiAdminSendMobileAppNotification(requestParameters: NotificationApiApiNotificationApiAdminSendMobileAppNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiAdminSendMobileAppNotification(requestParameters.adminSendMobileAppNotificationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiAdminTestCronMobileNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiAdminTestCronMobileNotification(requestParameters: NotificationApiApiNotificationApiAdminTestCronMobileNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiAdminTestCronMobileNotification(requestParameters.adminTestCronNotificationBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiCreateEmailNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiCreateEmailNotifications(requestParameters: NotificationApiApiNotificationApiCreateEmailNotificationsRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiCreateEmailNotifications(requestParameters.createEmailNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiDeleteEmailNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiDeleteEmailNotifications(requestParameters: NotificationApiApiNotificationApiDeleteEmailNotificationsRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiDeleteEmailNotifications(requestParameters.emailNotificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiDeleteWebPushSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiDeleteWebPushSubscription(requestParameters: NotificationApiApiNotificationApiDeleteWebPushSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiDeleteWebPushSubscription(requestParameters.webPushUnsubscribeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiDismissWebPushPrompt(options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiDismissWebPushPrompt(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetAdminPushNotificationUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetAdminPushNotificationUsers(requestParameters: NotificationApiApiNotificationApiGetAdminPushNotificationUsersRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetAdminPushNotificationUsers(requestParameters.groupId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetAdminPushNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetAdminPushNotifications(requestParameters: NotificationApiApiNotificationApiGetAdminPushNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetAdminPushNotifications(requestParameters.notificationType, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetEmailNotifications(options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetEmailNotifications(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetInAppNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetInAppNotifications(requestParameters: NotificationApiApiNotificationApiGetInAppNotificationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetInAppNotifications(requestParameters.page, requestParameters.pageSize, requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetInAppNotificationsUnreadCountRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetInAppNotificationsUnreadCount(requestParameters: NotificationApiApiNotificationApiGetInAppNotificationsUnreadCountRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetInAppNotificationsUnreadCount(requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetUserNotificationsByUserTypeRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetUserNotificationsByUserType(requestParameters: NotificationApiApiNotificationApiGetUserNotificationsByUserTypeRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetUserNotificationsByUserType(requestParameters.userType, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetWhatsappConversationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetWhatsappConversations(requestParameters: NotificationApiApiNotificationApiGetWhatsappConversationsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetWhatsappConversations(requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetWhatsappLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetWhatsappLogs(requestParameters: NotificationApiApiNotificationApiGetWhatsappLogsRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetWhatsappLogs(requestParameters.maxDate, requestParameters.messageStatus, requestParameters.messageType, requestParameters.minDate, requestParameters.page, requestParameters.pageSize, requestParameters.phone, requestParameters.templateName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetWhatsappTemplates(options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetWhatsappTemplates(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiGetWhatsappThreadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiGetWhatsappThread(requestParameters: NotificationApiApiNotificationApiGetWhatsappThreadRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiGetWhatsappThread(requestParameters.phone, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiMarkAllInAppNotificationsReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiMarkAllInAppNotificationsRead(requestParameters: NotificationApiApiNotificationApiMarkAllInAppNotificationsReadRequest = {}, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiMarkAllInAppNotificationsRead(requestParameters.scope, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiMarkInAppNotificationReadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiMarkInAppNotificationRead(requestParameters: NotificationApiApiNotificationApiMarkInAppNotificationReadRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiMarkInAppNotificationRead(requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiSaveWebPushSubscriptionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiSaveWebPushSubscription(requestParameters: NotificationApiApiNotificationApiSaveWebPushSubscriptionRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiSaveWebPushSubscription(requestParameters.webPushSubscribeBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiSendWhatsappRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiSendWhatsapp(requestParameters: NotificationApiApiNotificationApiSendWhatsappRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiSendWhatsapp(requestParameters.paramValue, requestParameters.templateName, requestParameters.toNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiSendWhatsappMarketingNotificationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiSendWhatsappMarketingNotification(requestParameters: NotificationApiApiNotificationApiSendWhatsappMarketingNotificationRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiSendWhatsappMarketingNotification(requestParameters.whatsappMarketingNotificationSuccessBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiToggleEmailNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiToggleEmailNotifications(requestParameters: NotificationApiApiNotificationApiToggleEmailNotificationsRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiToggleEmailNotifications(requestParameters.toggleUserEmailNotifications, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiUpdateEmailNotificationsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiUpdateEmailNotifications(requestParameters: NotificationApiApiNotificationApiUpdateEmailNotificationsRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiUpdateEmailNotifications(requestParameters.emailNotificationId, requestParameters.createEmailNotification, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiUpdatePushDigestFrequencyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiUpdatePushDigestFrequency(requestParameters: NotificationApiApiNotificationApiUpdatePushDigestFrequencyRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiUpdatePushDigestFrequency(requestParameters.updatePushDigestFrequency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiUpdatePushNotificationInteractionRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiUpdatePushNotificationInteraction(requestParameters: NotificationApiApiNotificationApiUpdatePushNotificationInteractionRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiUpdatePushNotificationInteraction(requestParameters.interactionType, requestParameters.notificationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {NotificationApiApiNotificationApiWhatsappAdminReplyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationApiWhatsappAdminReply(requestParameters: NotificationApiApiNotificationApiWhatsappAdminReplyRequest, options?: RawAxiosRequestConfig) {
        return NotificationApiApiFp(this.configuration).notificationApiWhatsappAdminReply(requestParameters.whatsappReplyBody, options).then((request) => request(this.axios, this.basePath));
    }
}

export const NotificationApiGetInAppNotificationsScopeEnum = {
    Classroom: 'Classroom',
} as const;
export type NotificationApiGetInAppNotificationsScopeEnum = typeof NotificationApiGetInAppNotificationsScopeEnum[keyof typeof NotificationApiGetInAppNotificationsScopeEnum];
export const NotificationApiGetInAppNotificationsUnreadCountScopeEnum = {
    Classroom: 'Classroom',
} as const;
export type NotificationApiGetInAppNotificationsUnreadCountScopeEnum = typeof NotificationApiGetInAppNotificationsUnreadCountScopeEnum[keyof typeof NotificationApiGetInAppNotificationsUnreadCountScopeEnum];
export const NotificationApiMarkAllInAppNotificationsReadScopeEnum = {
    Classroom: 'Classroom',
} as const;
export type NotificationApiMarkAllInAppNotificationsReadScopeEnum = typeof NotificationApiMarkAllInAppNotificationsReadScopeEnum[keyof typeof NotificationApiMarkAllInAppNotificationsReadScopeEnum];
